<!-- 路由容器 -->
<template>
    <transition name="slide-fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
export default {
    data() {
        return {

        };
    },

    components: {},

    computed: {},

    created() {},

    mounted() {},

    methods: {},
};

</script>
<style lang="scss" scoped>

</style>
